export default __webpack_public_path__ + "static/media/BiologyOptimized.f28f76b6.jp2";